import { Calculator } from 'lucide-react';

interface FormulaCellProps {
  value: string | number | null;
  readOnly?: boolean;
}

export function FormulaCell({ value }: FormulaCellProps) {
  // Formula é sempre read-only (calculada automaticamente)
  
  if (!value && value !== 0) {
    return <span className="text-gray-400 text-sm">-</span>;
  }

  // Formata número se for numérico
  const displayValue = typeof value === 'number' 
    ? value.toLocaleString('pt-BR', { maximumFractionDigits: 2 })
    : value;

  return (
    <div className="flex items-center gap-2 text-gray-700">
      <Calculator className="w-4 h-4 text-blue-500" />
      <span className="font-mono font-semibold">{displayValue}</span>
    </div>
  );
}
